import { render, staticRenderFns } from "./service_system.vue?vue&type=template&id=217c5c15&scoped=true&"
import script from "./service_system.vue?vue&type=script&lang=js&"
export * from "./service_system.vue?vue&type=script&lang=js&"
import style0 from "./service_system.vue?vue&type=style&index=0&id=217c5c15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217c5c15",
  null
  
)

export default component.exports